import React, {Component} from 'react';
import { fileKey, fileUrl } from '../../../../../util/file_url';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { trashIcon } from '../../../../Templates/icons'
export default class VideoPlayer extends Component {

    render() {
        const customRenderItem = (item, props) => <item.type {...item.props} {...props} />;
        const customRenderThumb = (children) =>
            children.map((item, index) => {
                return <div>{index + 1}</div>;
            });

        const videos = this.props.files.map((file, index) => {
            let filePath = file.path
            return <div>
                <video preload="metadata"
                    style={{ maxHeight: "40em", objectFit: "contain" }}
                    src={fileUrl(fileKey(file))} controls />
                    <p style={{bottom: "90%"}} className="legend">{filePath}
                    </p>
            </div>
        })
        return (
            <Carousel renderItem={customRenderItem} renderThumbs={customRenderThumb}>
                {videos}
            </Carousel>
        );
    }
};